import { SIDEBAR } from '../actions/types';
import { limpiarFiltros } from "./generalActios";
import { setFiltroGrupoPlanes, setPlanesDesdeBusqueda, resetGrupoPlanes } from '../actions/planesActions';
import { setTiposGrupoPlanes, setFiltroTipoPublicaciones, resetTipoPublicaciones } from '../actions/tiposPublicacionActions';
import { resetPublicaciones, seModificaronImagenes, setFiltroPublicacion, resetListPublicaciones } from '../actions/publicacionesActions';
import { resetSellers, setFiltroSeller } from './sellersActions';
import { resetFiltroLiquidaciones } from './LiquidacionesActions';
import { setFiltroOrdenes, resetOrdenes } from '../actions/ordenesActions';
import { resetFiltroUsuario, resetFiltroUsuarios, resetListUsuarios, setFiltroUsuarios } from './usuariosActions';
import { resetRebates } from './rebatesActions';

export const getSidebarItems = (userType, idSeller, idUser) => {
  const {
    isCategory,
    isAdminMod,
    isSellerAdmin,
    isSeller,
    isResetPassword,
    isSoloLectura,
    isProveedor,
    isContaduria,
    isTesoreria,
  } = userType;

  if (isResetPassword) return [];

  /* Si el usuario es de contaduría, solo puede ver "Detalle Liquidación" */
  if (isContaduria) {
    return [
      {
        id: 100,
        icon: "mdi mdi-bank",
        label: "Detalle Liquidacion",
        childItems: [
          {
            id: 101,
            icon: "mdi mdi-receipt",
            label: "Adm. Liquidacion",
            goToPath: "/Liquidaciones"
          },
        ]
      }
    ];
  }

  /* Si el usuario es Proveedor, solo puede ver "Gestión de Ordenes Proveedores" */
  if (isProveedor) {
    return [
      {
        id: 42,
        icon: "sl-icon-basket",
        label: "Gestión de Ordenes Proveedores",
        goToPath: "/OrdenesProveedores"
      }
    ];
  }

  /* obtener iconos desde pictogrammers.github.io/@mdi/font/2.0.46/ || simplelineicons.github.io/ */
  const sidebarItems = [
    {
      id: 10,
      icon: "sl-icon-people",
      label: "Sellers",
      isHidden: (isSoloLectura || isProveedor),
      childItems: [
        {
          id: 11,
          icon: "sl-icon-people",
          label: (isSellerAdmin || isSeller) ? "Gestión de Seller" : "Gestión de Sellers",
          isHidden: (isSoloLectura || isProveedor || isTesoreria),
          goToPath: (isSellerAdmin || isSeller) ? "/Sellers/Editar/" + idSeller : "/Sellers"
        },
        {
          id: 12,
          icon: "sl-icon-wallet",
          label: "Gestión Datos Bancarios",
          isHidden: (!isCategory && !isAdminMod && !isTesoreria),
          goToPath: "/Sellers/GestionDatosBancarios"
        },
      ]
    },
    //{
    //  id: 20,
    //  icon: "sl-icon-people",
    //  label: (!isAdminMod && !isSellerAdmin) ? "Gestión de Usuario" : "Gestión de Usuarios",
    //  isHidden: (isSoloLectura || isProveedor || isTesoreria),
    //  goToPath: (!isAdminMod && !isSellerAdmin) ? "/Usuarios/Editar/" + idUser : "/Usuarios"
    //},
    {
      id: 20,
      //icon: "sl-icon-people",
      icon: "sl-icon-user-following",
      label: "Usuarios",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 21,
          icon: "sl-icon-people",
          label: (!isAdminMod && !isSellerAdmin) ? "Gestión de Usuario" : "Gestión de Usuarios",
          isHidden: (isSoloLectura || isProveedor || isTesoreria),
          goToPath: (!isAdminMod && !isSellerAdmin) ? "/Usuarios/Editar/" + idUser : "/Usuarios"
        },

        //COMENTADO por ticket 2025111402
        //{
        //    id: 22,
        //    icon: "sl-icon-user",
        //    label: "Gestión Tipo Usuarios",
        //    isHidden: (isSoloLectura || isProveedor || isTesoreria || isSellerAdmin || isSeller),
        //    goToPath: "/Usuarios/TipoUsuarios"
        //},
      ]
    },
    {
      id: 30,
      icon: "mdi mdi-tag-multiple",
      label: "Publicaciones",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 31,
          icon: "mdi mdi-tag-multiple",
          label: "Gestión de Publicaciones",
          goToPath: "/Publicaciones"
        },
        {
          id: 32,
          icon: "mdi mdi-table-large",
          label: "Creacion Masiva",
          goToPath: "/Publicaciones/CreacionMasiva"
        },
        {
          id: 33,
          icon: "mdi mdi-table-large",
          label: "Actualización Masiva",
          goToPath: "/Publicaciones/ActualizacionMasiva"
        },
      ]
    },
    //{
    //  id: 40,
    //  icon: "sl-icon-basket",
    //  label: "Gestión de Ordenes",
    //  isHidden: isTesoreria,
    //  childItems: [
    //    {
    //      id: 41,
    //      icon: "sl-icon-basket",
    //      label: "Ordenes Sellers",
    //      isHidden: isProveedor,
    //      goToPath: "/Ordenes"
    //    },
    //    {
    //      id: 42,
    //      icon: "sl-icon-basket",
    //      label: "Ordenes Proveedores",
    //      isHidden: (isSellerAdmin || isSeller || isSoloLectura),
    //      goToPath: "/OrdenesProveedores"
    //    }
    //  ]
    //},
    {
      id: 40,
      icon: "sl-icon-basket",
      label: "Órdenes",
      isHidden: isTesoreria,
      childItems: [
        {
          id: 41,
          icon: "sl-icon-basket",
          label: "Gestión de Ordenes Sellers",
          isHidden: isProveedor,
          goToPath: "/Ordenes"
        },
        {
          id: 42,
          icon: "sl-icon-basket",
          label: "Gestión de Ordenes Proveedores",
          isHidden: (isSellerAdmin || isSeller || isSoloLectura),
          goToPath: "/OrdenesProveedores"
        }
      ]
    },
    //{
    //  id: 50,
    //  icon: "mdi mdi-square-inc-cash",
    //  label: "Gestión de Rebates",
    //  isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
    //  goToPath: "/Rebates"
    //},
    {
      id: 50,
      icon: "mdi mdi-square-inc-cash",
      label: "Rebates",
      isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
      childItems: [
        {
          id: 51,
          icon: "mdi mdi-square-inc-cash",
          label: "Gestión de Rebates",
          isHidden: (isSoloLectura || isSeller || isProveedor || isTesoreria),
          goToPath: "/Rebates"
        },
      ]
    },
    {
      id: 60,
      icon: "sl-icon-credit-card",
      label: "Grupo Planes",
      isHidden: (!isCategory && !isAdminMod),
      goToPath: "/Planes",
    },
    {
      id: 70,
      icon: "sl-icon-bag",
      label: "Tipo de publicaciones",
      isHidden: (!isCategory && !isAdminMod),
      goToPath: "/Tipo/Publicaciones",
    },
    {
      id: 80,
      icon: "mdi mdi-file-excel",
      label: "Exportables",
      isHidden: (isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 81,
          icon: "mdi mdi-file-excel",
          label: "Publicaciones",
          goToPath: "/Exportables/Publicaciones"
        },
        {
          id: 82,
          icon: "mdi mdi-file-excel",
          label: "Órdenes",
          goToPath: "/Exportables/Ordenes"
        },
        {
          id: 83,
          icon: "mdi mdi-file-excel",
          label: "Novedades",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Exportables/Novedades"
        },
        {
          id: 84,
          icon: "mdi mdi-file-excel",
          label: "Liquidaciones",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Exportables/Liquidaciones"
        },
        {
          id: 85,
          icon: "mdi mdi-file-excel",
          label: "Sellers",
          isHidden: (!isCategory && !isAdminMod),
          goToPath: "/Exportables/Sellers"
        }
      ]
    },
    {
      id: 90,
      icon: "mdi mdi-bank",
      label: "Liquidaciones",
      isHidden: (!isCategory && !isAdminMod),
      childItems: [
        {
          id: 91,
          icon: "mdi mdi-bullhorn",
          label: "Adm. Novedades",
          goToPath: "/Novedades"
        },
        {
          id: 92,
          icon: "mdi mdi-receipt",
          label: "Adm. Liquidacion",
          goToPath: "/Liquidaciones"
        },
        {
          id: 93,
          icon: "mdi mdi-note-plus-outline",
          label: "Gestion de conceptos",
          goToPath: "/Conceptos"
        },
        {
          id: 94,
          icon: "mdi mdi-file-excel",
          label: "Configuración Fee Logístico",
          goToPath: "/Liquidaciones/ActualizacionMasiva"
        }
      ]
    },
    {
      id: 100,
      icon: "mdi mdi-bank",
      label: "Detalle Liquidacion",
      isHidden: (isCategory || isAdminMod || isResetPassword || isSoloLectura || isProveedor || isTesoreria),
      childItems: [
        {
          id: 101,
          icon: "mdi mdi-receipt",
          label: "Adm. Liquidacion",
          goToPath: "/Liquidaciones"
        },
      ]
    }
  ]

  const filterByUserType = (sidebarItems) => {
    return sidebarItems
      .filter((item) => !item.isHidden)
      .map((item) => {
        if (item.childItems && item.childItems.length > 0) {
          item.childItems = filterByUserType(item.childItems);
        }
        return item;
      });
  };

  return filterByUserType(sidebarItems);
};

export const setHiddenItemsId = (itemsId) => (dispatch) => {
  dispatch({
    type: SIDEBAR.SET_HIDDEN_ITEMS,
    payload: itemsId
  });
};

export const filterByHiddenItemsId = (sidebarItems, hiddenItemsId) => {
  return sidebarItems
    .filter((item) => !hiddenItemsId?.includes(item.id))
    .map((item) => {
      if (item.childItems && item.childItems.length > 0) {
        item.childItems = filterByHiddenItemsId(item.childItems, hiddenItemsId);
      }
      return item;
    });
};

export const clearFilters = (userType, idSeller) => (dispatch) => {
  localStorage.removeItem("pagina");

  dispatch(
    limpiarFiltros({
      dashboard: true,
      ordenes: true,
      sellers: true,
      publicaciones: true,
      rebates: true,
      liquidaciones: true,
      grupoPlanes: true,
    })
  )

  dispatch(
    setFiltroOrdenes({})
  );

  dispatch(
    setFiltroSeller([])
  );

  dispatch(
    resetSellers([])
  );

  dispatch(
    resetFiltroLiquidaciones([])
  );

  dispatch(
    resetPublicaciones([])
  );

  dispatch(
    resetListPublicaciones([])
  );

  dispatch(
    setFiltroGrupoPlanes([])
  );

  dispatch(
    setFiltroTipoPublicaciones([])
  );

  dispatch(
    resetTipoPublicaciones([])
  );

  dispatch(
    resetGrupoPlanes([])
  );

  dispatch(
    resetOrdenes([])
  );

  dispatch(
    resetFiltroUsuario([])
  )

  dispatch(
    resetRebates([])
  );

  setTiposGrupoPlanes([]);
  setPlanesDesdeBusqueda([]);
  seModificaronImagenes(false);
  setFiltroPublicacion({ idSeller: userType.isCategory || userType.isAdminMod ? null : idSeller });
};